import React, {FC} from 'react';
import { ContentPanelContainer } from './content-panel-contaner';
import { ContentHeader } from './content-header';
import { ContentPanel } from './content-panel';

export const About:FC = () => {

    return (
        <ContentPanelContainer>
            <ContentHeader headerText="welcome..."/>
            <ContentPanel>
                ...and thank you for taking the time to visit my web portfolio.
                I built this page to give prospective employers insight into my
                design aesthetic as well as my technical ability.  This site is 
                written in React/Typescript and is hosted via AWS Lightsail.  It
                is a simple SPA with no back-end logic.  All of the React components
                in this SPA were built by me from scratch; I did not use any 
                3rd-party component libraries or plugins.
            </ContentPanel>
            <ContentHeader headerText="my objective..."/>
            <ContentPanel>
                ...is to find meaningful, fulfilling long-term employment with a 
                company whose culture is focused both on creating a quality
                product or service for its customers and fostering a healthy, 
                appreciative and rewarding work environment for its employees.  
                My ideal employer has either a written or unwritten 
                hiring policy in line with the philosophy of Dr. Robert I. Sutton 
                and prioritizes the cultural 'fit' of 
                prospective employees at least as hight as technical ability.  
            </ContentPanel>
            <ContentHeader headerText="when i'm not coding..."/>
            <ContentPanel>
                I enjoy reading, photography, woodworking and hiking.  Since moving
                back east after living in Arizona for 15 years, the hiking and 
                photography have taken a back seat to woodworking.  I finally have the
                woodshop I always wanted set up in my basement which provides another wonderful
                outlet for creativity.  It's also come in handy for the 
                countless home improvement
                projects I inherited when my wife and I purchased our home here in 
                Kingston, NH.
            </ContentPanel>
        </ContentPanelContainer>
    )
}